import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LayoutModule } from "../../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../freightconfirmation/app.sharemodule";
import { TranslateModule } from "@ngx-translate/core";
import { BiddingComponent } from "./bidding.component";
import { WaypointsMapModule } from "../../map/WaypointsMap/Waypoints.module";

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        FormsModule,
        SharedModule,
        TranslateModule.forChild(),
        // WaypointsMapModule
    ],
    exports: [BiddingComponent],
    declarations: [BiddingComponent]
})
export class BiddingSharedModule { }
